import { useTranslation } from 'react-i18next'

import { cn } from '@/lib/utils'

import './restaurant-marquee.css'

const RESTAURANT_LOGOS = [
    { src: '/escandallos-de-costes.webp', altKey: 'foodCost.marquee.alt.costing' },
    { src: '/food-cost-restaurante.webp', altKey: 'foodCost.marquee.alt.foodCostRestaurant' },
    { src: '/calcular-precio-de-venta-de-un-plato.webp', altKey: 'foodCost.marquee.alt.salePrice' },
    { src: '/calcular-precio-plato-restaurante.webp', altKey: 'foodCost.marquee.alt.platePrice' },
    { src: '/app-hosteleria.webp', altKey: 'foodCost.marquee.alt.hospitalityApp' },
    { src: '/margen-restaurante.webp', altKey: 'foodCost.marquee.alt.margin' },
    { src: '/costes-restaurante.webp', altKey: 'foodCost.marquee.alt.costs' },
    { src: '/gestion-hosteleria.webp', altKey: 'foodCost.marquee.alt.origin' },
    { src: '/restaurante-independiente.webp', altKey: 'foodCost.marquee.alt.esRaco' },
    { src: '/food-cost/client-logos/bodeguita.webp', altKey: 'foodCost.marquee.alt.bodeguita' },
    {
        src: '/food-cost/client-logos/bosse-bistro.webp',
        altKey: 'foodCost.marquee.alt.bosseBistro',
        className: 'restaurant-marquee__logo--bosse',
    },
    { src: '/food-cost/client-logos/blossom.webp', altKey: 'foodCost.marquee.alt.blossom' },
    { src: '/food-cost/client-logos/wilko.webp', altKey: 'foodCost.marquee.alt.wilko' },
    {
        src: '/food-cost/client-logos/la-ratona.webp',
        altKey: 'foodCost.marquee.alt.laRatona',
        className: 'restaurant-marquee__logo--ratona',
    },
] as const

const MARQUEE_ALT_FALLBACKS: Record<(typeof RESTAURANT_LOGOS)[number]['altKey'], string> = {
    'foodCost.marquee.alt.costing': 'Escandallos de costes',
    'foodCost.marquee.alt.foodCostRestaurant': 'Idilio Cocina Vino',
    'foodCost.marquee.alt.salePrice': 'Calcular precio de venta de un plato',
    'foodCost.marquee.alt.platePrice': 'Calcular precio plato restaurante',
    'foodCost.marquee.alt.hospitalityApp': 'App hostelería',
    'foodCost.marquee.alt.margin': 'Margen restaurante',
    'foodCost.marquee.alt.costs': 'Costes restaurante',
    'foodCost.marquee.alt.origin': 'Origen',
    'foodCost.marquee.alt.esRaco': 'Es Racó de Macaret',
    'foodCost.marquee.alt.bodeguita': 'Bodeguita Cervecería Tapería',
    'foodCost.marquee.alt.bosseBistro': 'Bossé bistró',
    'foodCost.marquee.alt.blossom': 'Blossom',
    'foodCost.marquee.alt.wilko': 'Wilko',
    'foodCost.marquee.alt.laRatona': 'La Ratona',
}

function LogoGroup({ idSuffix = '' }: { idSuffix?: string }) {
    const { t } = useTranslation()

    return (
        <>
            {RESTAURANT_LOGOS.map(logo => (
                <img
                    key={`${logo.src}${idSuffix}`}
                    src={logo.src}
                    alt={t(logo.altKey, MARQUEE_ALT_FALLBACKS[logo.altKey])}
                    loading='lazy'
                    decoding='async'
                    className={cn('restaurant-marquee__logo', 'className' in logo ? logo.className : undefined)}
                />
            ))}
        </>
    )
}

export function RestaurantNamesMarquee({ className }: { className?: string }) {
    return (
        <div className={cn('border-y border-[#D8CFC0] bg-[#EDE6DA] py-8 md:py-10', className)}>
            <div className='restaurant-marquee'>
                <div className='restaurant-marquee__track'>
                    <div className='restaurant-marquee__group'>
                        <LogoGroup />
                    </div>
                    <div className='restaurant-marquee__group' aria-hidden>
                        <LogoGroup idSuffix='-dup' />
                    </div>
                </div>
            </div>
        </div>
    )
}
